import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createDeviceCalendarEventsSchemas } from 'shared/db/validation/schema/deviceCalendarEvents';
import { Validator } from 'shared/db/validation/validator';
import {
    DeviceCalendarEventRawRecord,
    DeviceCalendarEventUpdateRawRecord,
} from 'shared/types/DeviceCalendarEvents';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { DeviceCalendarEventsDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createDeviceCalendarEventsSchemas();

const addValidator = createDBEntityValidator<DeviceCalendarEventRawRecord>(
    schemas.add,
);
const updateValidator =
    createDBEntityValidator<DeviceCalendarEventUpdateRawRecord>(schemas.update);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-device-calendar-events'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createDeviceCalendarEventsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const deviceCalendarEventsInputValidation: DeviceCalendarEventsDBValidation =
    {
        add: createDeviceCalendarEventsInputValidation(
            addValidator,
            validationStrategy,
        ),
        update: createDeviceCalendarEventsInputValidation(
            updateValidator,
            validationStrategy,
        ),
        delete: createDeviceCalendarEventsInputValidation(
            deleteValidator,
            validationStrategy,
        ),
    };
